import React from 'react';
import { Column } from 'primereact/column';
import { Messages } from 'primereact/messages';
import { DataTable } from 'primereact/datatable';
import { ButtonClose, ButtonYes } from '../../../components/Buttons';
import { ModalDialog } from '../../../components/ModalDialog';
import { formatMemberName } from '../../../../utils/texts';
import { Label } from '../../../components/form';

export const DateOverlapDialog = ({ overlaps, isVisible, onHide, onClickConfirm, msgs }) => {
    
    const dateTemplate = (rowData) => {
        return rowData.date_to ? `${rowData.date_from} – ${rowData.date_to}` : rowData.date_from;
    }

    const numberTemplate = (rowData) => {
        const url = window.location.href;
        const trimmed_url = url.slice(0, url.lastIndexOf('/'));
        return (
            <a href={`${trimmed_url}/${rowData.id}`} target='_blank' rel='noopener noreferrer'>
                {rowData.number}
            </a>
        );

    }

    return (
        <ModalDialog
            visible={isVisible}
            header='Potvrďte uložení'
            style={{ width: 600 }}
            footer={
                <>
                    <ButtonClose label='Zpět' onClick={onHide} />
                    <ButtonYes label='Uložit' onClick={onClickConfirm} />
                </>
            }
            onHide={onHide}
        >
            <Messages ref={msgs} className='flex-center' />
            <div className='dialog-text'>
                <span className='dialog-text__warning'>
                    <span>
                        Zvolený termín se překrývá s následujícími existujícími zasedáními.
                        Opravdu chcete tento termín uložit?
                    </span>
                </span>
            </div>

            <div style={{ marginTop: '1rem' }} />

            <div>
                <DataTable
                    value={overlaps}
                    stripedRows
                    size='small'
                    emptyMessage='Nenalezeny žádné překryvy'
                >
                    <Column
                        field='number'
                        header={
                            <Label htmlFor='number' text='Číslo' info={<>Odkaz bude otevřen v nové kartě.</>} />
                        }
                        body={numberTemplate}
                        bodyClassName='break-word'
                    />
                    <Column field='date' header='Datum' body={dateTemplate} bodyClassName='break-word' />
                </DataTable>
            </div>

        </ModalDialog>
    );
};
